import React from 'react';
import Input from '../../ui/Input';
import Label from '../../ui/Label';

const ClientFormDetails = ({ formData, handleInputChange }) => {
  return (
    <div className="p-4 sm:p-6 border-b border-gray-100">
      <div className="grid grid-cols-1 sm:grid-cols-2 2xl:grid-cols-3 gap-x-6 gap-y-5">
        
        {/* Row 1 */}
        <div>
          <Label>Име</Label>
          <Input name="name" value={formData.name || ''} onChange={handleInputChange} placeholder="Дженерал Сълюшън ЕООД" required />
        </div>
        <div>
          <Label>Град</Label>
          <Input name="city" value={formData.city || ''} onChange={handleInputChange} placeholder="София" />
        </div>
        <div>
          <Label>МОЛ</Label>
          <Input name="mol" value={formData.mol || ''} onChange={handleInputChange} placeholder="Иван Иванов" />
        </div>

        {/* Row 2 */}
        <div>
          <Label>ЕИК</Label>
          <Input name="idNumber" value={formData.idNumber || ''} onChange={handleInputChange} placeholder="123456789" />
        </div>
        <div>
          <Label>Адрес</Label>
          <Input name="address" value={formData.address || ''} onChange={handleInputChange} placeholder="Бул. Стамболийски 8" />
        </div>
        <div>
          <Label>Телефон</Label>
          <Input name="phoneNumber" value={formData.phoneNumber || ''} onChange={handleInputChange} placeholder="0878000000" />
        </div>

        {/* Row 3 */}
        <div className="hidden 2xl:block"></div>
        <div className="hidden sm:block"></div>
        <div>
          <Label>ДДС номер</Label>
          <Input name="vatNumber" value={formData.vatNumber || ''} onChange={handleInputChange} placeholder="BG123456789" />
        </div>

      </div>
    </div>
  );
};

export default ClientFormDetails;
